import React from 'react';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import Box from '@atlaskit/primitives/box';
import { xcss } from '@atlaskit/primitives/xcss';

const dividerStyles = xcss({
	width: '100%',
	display: 'flex',
	borderBottomWidth: 'border.width',
	borderBottomStyle: 'solid',
	borderColor: 'color.border',
});

type DividerProps = {
	testId?: string;
};

export const Divider = ({ testId }: DividerProps): React.JSX.Element => (
	<Box xcss={dividerStyles} testId={testId} />
);
